import { Link } from "react-router-dom";
import { LogIn, LogOut, History as HistoryIcon, Settings as SettingsIcon, Loader2, UserPlus } from "lucide-react";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useSession } from "@/hooks/useSession";

export function UserMenu() {
  const { user, loading, signOut, supabaseEnabled } = useSession();

  if (!supabaseEnabled) return null;

  if (loading) {
    return <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />;
  }

  if (!user) {
    return (
      <>
        <Button variant="ghost" size="sm" asChild className="hover:bg-muted/50">
          <Link to="/login">
            <LogIn className="h-4 w-4" />
            <span className="hidden sm:inline ml-1">Sign in</span>
          </Link>
        </Button>
        <Button size="sm" asChild className="glow">
          <Link to="/login?tab=signup">
            <UserPlus className="h-4 w-4" />
            <span className="hidden sm:inline ml-1">Sign up</span>
          </Link>
        </Button>
      </>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2 font-mono text-[11px] hover:bg-muted/50">
          <span className="h-2 w-2 rounded-full bg-success animate-glow-pulse" />
          {user.email?.split("@")[0] ?? "User"}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-card/95 backdrop-blur-xl border-border/50">
        <p className="px-2 py-1.5 font-mono text-[11px] text-muted-foreground truncate">
          {user.email}
        </p>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild className="cursor-pointer">
          <Link to="/history" className="flex items-center gap-2 text-sm">
            <HistoryIcon className="h-4 w-4" />
            History
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="cursor-pointer">
          <Link to="/settings" className="flex items-center gap-2 text-sm">
            <SettingsIcon className="h-4 w-4" />
            Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut} className="cursor-pointer text-sm text-destructive focus:text-destructive">
          <LogOut className="h-4 w-4 mr-2" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
